import { Link } from 'react-router-dom'
import LegalLayout from './LegalLayout'
import { LEGAL_ENTITY as ED } from './legalEntity'

/** Publisher and host identity, as required by article 6-III of the LCEN. */
export default function MentionsLegales() {
  return (
    <LegalLayout
      title="Mentions légales"
      description="Identité de l’éditeur et de l’hébergeur du service Espace Client, édité par ISEFFI."
    >
      <h2>1. Éditeur du site</h2>
      <p>
        Le site <strong>{ED.siteUrl}</strong> et le service <strong>{ED.service}</strong> sont
        édités par <strong>{ED.societe}</strong>, {ED.formeJuridique} au capital de {ED.capital},
        immatriculée au registre du commerce et des sociétés de {ED.rcsVille} sous le numéro{' '}
        {ED.siren}, dont le siège social est situé {ED.adresse}.
      </p>
      <ul>
        <li>SIRET du siège : {ED.siret}</li>
        <li>Numéro de TVA intracommunautaire : {ED.tva}</li>
        <li>Directeur de la publication : {ED.directeur}</li>
        <li>
          Contact : <a href={`mailto:${ED.email}`}>{ED.email}</a> — {ED.telephone}
        </li>
      </ul>

      <h2>2. Hébergement</h2>
      <p>
        Le site et l’application {ED.service} sont hébergés par <strong>{ED.hebergeur}</strong>,{' '}
        {ED.hebergeurAdresse} — téléphone : {ED.hebergeurTelephone}.
      </p>
      <p>Localisation des serveurs : {ED.hebergeurLocalisation}.</p>

      <h2>3. Propriété intellectuelle</h2>
      <p>
        La marque {ED.service}, le logo, la charte graphique, les textes, les interfaces et
        l’ensemble des contenus du site sont la propriété de {ED.societe} ou de ses partenaires et
        sont protégés par le droit de la propriété intellectuelle. Toute reproduction ou
        représentation, totale ou partielle, sans autorisation écrite préalable, est interdite.
      </p>
      <p>
        Les marques, logos et contenus des entreprises utilisatrices affichés dans leur espace
        (logo, catalogue, documents) restent la propriété de ces entreprises. {ED.societe} n’en
        acquiert aucun droit et se limite à les afficher pour les besoins du service.
      </p>

      <h2>4. Données personnelles</h2>
      <p>
        Le traitement des données personnelles est décrit en détail dans la{' '}
        <Link to="/confidentialite">politique de confidentialité</Link>. Toute demande relative à
        vos données peut être adressée à <a href={`mailto:${ED.email}`}>{ED.email}</a>.
      </p>

      <h2>5. Responsabilité</h2>
      <p>
        {ED.societe} met en œuvre les moyens raisonnables pour assurer l’exactitude des informations
        publiées sur le site et la disponibilité du service. Les données métier (factures,
        commandes, devis, documents) affichées dans l’espace client proviennent du système de
        gestion de l’entreprise concernée : {ED.societe} les restitue sans en modifier le contenu et
        n’en garantit ni l’exactitude ni l’exhaustivité, qui relèvent de cette entreprise.
      </p>
      <p>
        Les conditions d’utilisation du service figurent dans les{' '}
        <Link to="/cgu">conditions générales d’utilisation</Link>, et les conditions de souscription
        dans les <Link to="/cgv">conditions générales de vente</Link>.
      </p>

      <h2>6. Liens hypertextes</h2>
      <p>
        Le site peut contenir des liens vers des sites tiers, notamment vers celui de l’entreprise
        dont vous êtes client. {ED.societe} n’exerce aucun contrôle sur ces sites et décline toute
        responsabilité quant à leur contenu.
      </p>

      <h2>7. Droit applicable</h2>
      <p>
        Les présentes mentions légales sont soumises au droit français. Tout litige relatif à leur
        interprétation ou à leur exécution relève des tribunaux compétents dans les conditions
        prévues par les <Link to="/cgv">conditions générales de vente</Link>.
      </p>
    </LegalLayout>
  )
}
